import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;
const CLASS = "incluway-letter-spacing";
const STYLE_ID = "incluway-letter-spacing-style";
const EXCLUDE = "#incluway-widget-root";

function toLetterSpacing(multiplier: number) {
  const m = Number.isFinite(multiplier)
    ? Math.max(0, Math.min(3, multiplier))
    : 0;

  return `${(m * 0.06).toFixed(3)}em`;
}

export function setLetterSpacing(multiplier: number) {
  if (!multiplier || multiplier <= 0) {
    disableLetterSpacing();
    return;
  }

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS} :not(${EXCLUDE}):not(${EXCLUDE} *) {
  letter-spacing: var(--incluway-letter-spacing, 0em) !important;
}
`.trim(),
  );

  ROOT.style.setProperty(
    "--incluway-letter-spacing",
    toLetterSpacing(multiplier),
  );
  ROOT.classList.add(CLASS);
}

export function disableLetterSpacing() {
  ROOT.classList.remove(CLASS);
  ROOT.style.removeProperty("--incluway-letter-spacing");
  removeStyleTag(STYLE_ID);
}
